import React, { SyntheticEvent } from "react";
import { Nav } from "rsuite";

const BottomMenu = ({
  menu,
  onSelect,
  activePath,
}: {
  menu: any;
  onSelect: any;
  activePath: string;
}) => {
  return (
    <Nav>
      {menu.map((item: any) => {
        return item.child.length <= 0 ? (
          <Nav.Item
            key={item.menu_url}
            eventKey={item.menu_url}
            onSelect={(
              eventKey: string | undefined,
              event: SyntheticEvent<Element, Event>
            ) => {
              onSelect(eventKey, item.page_type);
            }}
          >
            {item.menu_label}
          </Nav.Item>
        ) : (
          <Nav.Menu
            key={"4"}
            eventKey={"4"}
            trigger="hover"
            title={item.menu_label}
          >
            {item.child.map((child: any) => {
              return (
                <Nav.Item
                  key={child.menu_url}
                  active={activePath === `/${child.menu_url}`}
                  onSelect={(
                    eventKey: string | undefined,
                    event: SyntheticEvent<Element, Event>
                  ) => {
                    onSelect(eventKey, child.page_type);
                  }}
                  eventKey={child.menu_url}
                >
                  {child.menu_label}
                </Nav.Item>
              );
            })}
          </Nav.Menu>
        );
      })}
    </Nav>
  );
};

export default BottomMenu;
